export const CONDUCTOR_COOKIE_NAME = "joszaki-conductor";
export const CONDUCTOR_COOKIE_MAX_AGE = 31536000;
export const CONDUCTOR_SWITCH_MODES = ["off", "opt-in", "opt-out", "live"];
export const CONDUCTOR_PATH = "/vezerlo";
export const CONDUCTOR_VERSION_KEY = "conductor_version";
export const CONDUCTOR_VERSION = "v1";

export function parseConductorSwitch(value) {
  const mode = typeof value === "string" ? value.trim().toLowerCase() : "";
  return CONDUCTOR_SWITCH_MODES.includes(mode) ? mode : "off";
}

export function isConductorPath(path) {
  return path === CONDUCTOR_PATH || path.startsWith(`${CONDUCTOR_PATH}/`);
}

export function conductorServedByV2(mode, cookieValue) {
  switch (parseConductorSwitch(mode)) {
    case "opt-in":
      return cookieValue === "v2";
    case "opt-out":
      return cookieValue !== "v1";
    case "live":
      return true;
    default:
      return false;
  }
}

/**
 * Must match the v2 app's authCookieDomain (joszaki-frontend-v2 app/utils/authCookie.ts): the main
 * domain, or a host-only cookie where the browser would reject that Domain. Any other domain would
 * leave a second cookie of the same name that the other app cannot clear.
 */
export function conductorCookieDomain(mainDomain, hostname) {
  if (!mainDomain || !mainDomain.includes(".")) {
    return "";
  }
  const host = (hostname || "").toLowerCase();
  return host === mainDomain || host.endsWith(`.${mainDomain}`)
    ? mainDomain
    : "";
}

export function conductorCookieOptions(domain) {
  return {
    maxAge: CONDUCTOR_COOKIE_MAX_AGE,
    ...(domain ? { domain } : {}),
    path: "/",
    sameSite: "lax",
  };
}

export function setConductorCookie($cookie, value, domain) {
  if (domain) {
    $cookie.remove(CONDUCTOR_COOKIE_NAME, { path: "/" });
  }
  if (value) {
    $cookie.set(CONDUCTOR_COOKIE_NAME, value, conductorCookieOptions(domain));
    return;
  }
  $cookie.remove(CONDUCTOR_COOKIE_NAME, {
    ...(domain ? { domain } : {}),
    path: "/",
  });
}

export function conductorToggle(mode) {
  switch (parseConductorSwitch(mode)) {
    case "opt-in":
      return { value: "v2", labelKey: "conductor.navbar.switchToV2" };
    case "opt-out":
      return { value: null, labelKey: "conductor.navbar.backToV2" };
    default:
      return null;
  }
}
